module.exports = __webpack_public_path__ + "static/media/longest-drive.97a18bab.png";